import React from "react"

function Email() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 310.115 310.115"
      version="1.1"
      viewBox="0 0 310.115 310.115"
      xmlSpace="preserve"
    >
      <path
        fill="#D07C40"
        d="M309.691 116.824c-1.401-4.069-3.605-7.906-6.852-11.153L175.595 9.17c-16.594-12.226-25.051-12.226-41.364 0L7.537 105.671c-3.247 3.247-5.46 7.084-6.862 11.153l154.237 135.304c.001.001 154.779-135.304 154.779-135.304z"
      ></path>
      <path
        fill="#E4E7E7"
        d="M39.082 29.852h231.95v193.282H39.082V29.852z"
      ></path>
      <path
        fill="#E8AB54"
        d="M16.351 297.203l138.523-107.905 138.88 107.915a29.024 29.024 0 0012.158-11.704L175.595 183.152c-16.449-12.139-25.099-12.332-41.364 0L4.116 285.345a28.968 28.968 0 0012.235 11.858z"
      ></path>
      <path
        fill="#C2C5C5"
        d="M77.741 78.175v19.329h154.634V78.175H77.741zm0 57.977h154.634v-19.32H77.741v19.32z"
      ></path>
      <path
        fill="#E8AB54"
        d="M155.058 232.799l154.634-115.975v164.298c0 16.014-12.98 28.994-28.994 28.994H29.418c-16.014 0-28.994-12.98-28.994-28.994V116.824l154.634 115.975z"
      ></path>
      <path
        fill="#F4B459"
        d="M283.79 309.796c6.263-.667 11.926-3.286 16.343-7.306L154.874 189.288 9.953 302.49c4.426 4.03 10.08 6.64 16.362 7.316l257.475-.01z"
      ></path>
      <path
        fill="#F9D7A7"
        d="M4.116 295.009a29.095 29.095 0 0012.235 11.868l138.523-107.896 138.88 107.905a29.024 29.024 0 0012.158-11.704L175.595 192.798c-18.256-13.521-22.683-14.139-41.364 0L4.116 295.009z"
      ></path>
    </svg>
  )
}

export default Email
